import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import { 
    faMagnifyingGlass,
    faCircleInfo,
    faCalendar,
    faDownload,
    faPencil,
    faHatWizard,
    faCirclePlus,
    faBell as falBell,
    faTimes
} from '@fortawesome/pro-light-svg-icons'
import { faXmark,
    faPipe,
    faCheck,
    faChartNetwork,
    faCircle,
    faChartScatter,
    faMemo,
    faFlask,
    faChevronDoubleRight,
    faPlus,
    faSlidersUp,
    faBell as fasBell,
} from '@fortawesome/pro-regular-svg-icons'
import { faAngleDown,
    faExclamationCircle,
    faExclamationTriangle,
    faCheckCircle,
    faBellExclamation,
    faCircleCheck,
    faFolder,
    faGridDividers,
    faSuitcase,
    faCaretRight,
    faBell,
    faCheck as fasCheck,
    faArrowRightFromBracket,
    faCircleXmark,
    faXmark as fasXmark,
    faAngleLeft,
    faAngleRight,
    faCog
} from '@fortawesome/pro-solid-svg-icons'

library.add(
    faMagnifyingGlass,
    faCircleInfo,
    faCalendar,
    faXmark,
    fasXmark,
    faPipe,
    faCheck,
    fasCheck,
    faDownload,
    faChartNetwork,
    faExclamationCircle,
    faExclamationTriangle,
    faCheckCircle,
    faBellExclamation,
    faAngleDown,
    faCircleCheck,
    faCircle,
    faChartScatter,
    faFolder,
    faGridDividers,
    faMemo,
    faCaretRight,
    faBell,
    falBell,
    fasBell,
    faSuitcase,
    faPencil,
    faHatWizard,
    faFlask,
    faArrowRightFromBracket,
    faChevronDoubleRight,
    faCirclePlus,
    faPlus,
    faCircleXmark,
    faTimes,
    faSlidersUp,
    faAngleLeft,
    faAngleRight,
    faCog
);

export default FontAwesomeIcon;